import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/deuda';
import DeudaReporte from './DeudaReporte';

const mstp = state => {
    return {...state.Reportes, permisos: state.login.me.permisos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(DeudaReporte)
